import styled from 'styled-components';
import { breakpoints } from '../../styles/theme';
import SummaryPriceDetails from './SummaryDiscountDetailsTemplate';
import { rem } from 'polished';

export const SummaryDiscountDetailsStyled = styled(SummaryPriceDetails)`
    border-top: ${rem(1)} solid ${({ theme }) => theme.colors.grey16};

    .Collapsible__contentInner {
        padding-bottom: ${rem(30)};
    }

    .titleWrapperButton {
        width: 100%;
    }

    .titleWrapper {
        display: flex;
        justify-content: space-between;
        align-items: center;
        cursor: pointer;
        padding: ${rem(43)} 0;
        width: 100%;

        .title {
            font-size: ${({ theme }) => theme.fontSizes.textBig};
            font-weight: ${({ theme }) => theme.fontWeights.textBold};
            line-height: 1.4;
        }

        svg {
            height: ${rem(14)};
        }

        .isOpen {
            svg {
                path {
                    stroke: ${({ theme }) => theme.colors.black};
                    stroke-width: 2;
                }
            }
        }

        .isClose {
            svg {
                width: ${rem(25)};
                height: ${rem(25)};
                margin-right: ${rem(10)};
                path {
                    fill: ${({ theme }) => theme.colors.black};
                }
            }
        }
    }

    .section {
        display: flex;
        justify-content: space-between;
        flex-direction: column;

        @media (min-width: ${breakpoints.sm}px) {
            flex-direction: row;
        }

        .description {
            margin-top: 0;
            margin-bottom: ${rem(50)};

            @media (min-width: ${breakpoints.sm}px) {
                width: 50%;
                margin-bottom: 0;
            }
        }

        .discounts {
            .discount,
            .totalPrice {
                display: flex;
                justify-content: space-between;
                font-size: ${({ theme }) => theme.fontSizes.textBase};
                border-top: 1px solid ${({ theme }) => theme.colors.grey25};
                padding: ${rem(16)} 0;

                .isBold {
                    font-weight: ${({ theme }) => theme.fontWeights.textBold};
                }
            }

            .totalPrice {
                border-bottom: 1px solid ${({ theme }) => theme.colors.grey25};
                font-weight: ${({ theme }) => theme.fontWeights.textBold};
            }

            @media (min-width: ${breakpoints.sm}px) {
                width: 50%;
            }
        }
    }
`;
